import * as React from 'react';
import { PVAPage, PVAUserSelect, LoadingIndicatorMini, PonderaModal, PVAContainerSimple, PVASelect } from '../../../components';
import { UserScoreCardNote, ScoreCardGroup, ScoreCardGroupCharacteristic, UserScoreCardGroupCharacteristic, ScoreCard } from '../../../models';
import { UserScoreCardNoteDataService, UserScoreCardGroupCharacteristicDataService, ScoreCardDataService } from '../../../services';
import { BaseRouteProps } from '../../../interfaces';
import { UserStore, FilterStore } from '../../../stores';
import { Roles } from '../../../stores/Constants';
import { computed } from 'mobx';
import { observer, inject } from 'mobx-react';
import * as moment from 'moment';
import './ScoreCardView.css';

interface ScoreCardState {
    orgId: number;
    surveyId: number;
    teamId: number | undefined;
    userId: number;
    surveyVersionId: number;
    miniLoad: boolean;
    listView: boolean;
    open: boolean;
    scoreCards: ScoreCard[];
    selectedScoreCardId?: number;
    groups: ScoreCardGroup[];
    scores: UserScoreCardGroupCharacteristic[];
    notes: UserScoreCardNote[];
    note: string;
    isPublic: boolean;
}

interface ScoreCardProps extends BaseRouteProps<{}> {
    UserStore?: UserStore;
    FilterStore?: FilterStore;
}

@inject('UserStore', 'FilterStore') @observer
export class ScoreCardView extends React.Component<ScoreCardProps, ScoreCardState> {
    private scoreCardDataService = new ScoreCardDataService(this.props.notificationService);
    // private scoreCardGroupDataService = new ScoreCardGroupDataService(this.props.notificationService);
    private userScoreCardGroupCharacteristicDataService = new UserScoreCardGroupCharacteristicDataService(this.props.notificationService);
    private userScoreCardNoteDataService = new UserScoreCardNoteDataService(this.props.notificationService);

    constructor(props: ScoreCardProps) {
        super(props);

        this.state = {
            orgId: 0,
            surveyId: 0,
            teamId: 0,
            userId: 0,
            surveyVersionId: 0,
            miniLoad: false,
            listView: false,
            open: false,
            groups: [],
            scores: [],
            notes: [],
            note: '',
            isPublic: false,
            scoreCards: []
        };
    }

    @computed get organization() {
        if (this.props.FilterStore && this.props.FilterStore.organization) {
            return this.props.FilterStore.organization;
        }
        return null;
    }

    @computed get survey() {
        if (this.props.FilterStore && this.props.FilterStore.survey) {
            return this.props.FilterStore.survey;
        }
        return null;
    }

    @computed get surveyVersion() {
        if (this.props.FilterStore && this.props.FilterStore.surveyVersion) {
            return this.props.FilterStore.surveyVersion;
        }
        return null;
    }

    @computed get userRole() {
        return this.props.UserStore!.userInfo.userRole;
    }

    @computed get team() {
        if (this.props.FilterStore && this.props.FilterStore.team) {
            return this.props.FilterStore.team;
        }
        return null;
    }

    @computed get teams() {
        if (this.props.FilterStore && this.props.FilterStore.teams) {
            return this.props.FilterStore.teams;
        }
        return [];
    }

    @computed get teamId() {
        return this.props.FilterStore!.teamId;
    }

    @computed get users() {
        return this.props.FilterStore!.users;
    }

    toggleModal(groupInd: number, characteristicInd: number) {
        if (this.state.groups) {
            var scoreCardGroups = this.state.groups;

            scoreCardGroups[groupInd].scoreCardGroupCharacteristics[characteristicInd].showModal = !scoreCardGroups[groupInd].scoreCardGroupCharacteristics[characteristicInd].showModal;

            this.setState({
                groups: scoreCardGroups
            });
        }
    }

    private updateReport() {
        this.setState({
            miniLoad: false
        });

        if (this.state.userId && this.state.selectedScoreCardId) {
            this.userScoreCardGroupCharacteristicDataService.getAllByUser(this.state.userId, this.state.selectedScoreCardId).then((scores: UserScoreCardGroupCharacteristic[]) => {
                this.setState({
                    scores: scores,
                    notes: []
                });
                if (this.state.userId && this.state.selectedScoreCardId) {
                    this.userScoreCardNoteDataService.getAllByUser(this.state.userId, this.state.selectedScoreCardId).then((notes: UserScoreCardNote[]) => {
                        this.setState({
                            notes: notes
                        });
                    });
                }
            });
        }
    }

    private update() {
        if (this.organization && this.organization.id !== this.state.orgId) {
            this.scoreCardDataService.getAllByOrganization(this.organization.id).then((scoreCards: ScoreCard[]) => {
                this.setState({
                    scoreCards: scoreCards
                });
            });

            this.setState(
                {
                    selectedScoreCardId: undefined,
                    groups: [],
                    orgId: this.organization.id,
                    miniLoad: true
                },
                this.updateReport);
        }

        if (this.state.teamId !== this.teamId) {
            this.setState(
                {
                    teamId: this.teamId,
                    miniLoad: true
                }, 
                this.updateReport);
        }
    }

    componentDidMount() {
        // this.scoreCardDataService.getAllByOrganization(this.organization!.id).then((scoreCards: ScoreCard[]) => {
        //     this.setState({
        //         scoreCards: scoreCards
        //     });
        // });
        // this.scoreCardGroupDataService.getAll().then((fusionGroups: ScoreCardGroup[]) => {
        //     this.setState({
        //         groups: fusionGroups
        //     });
        // });
        this.update();
    }

    componentWillReact() {
        this.update();
    }

    public submit(e: any) {
        var userId = Number(e.target.value);
        this.props.FilterStore!.interactionReportUserId = userId;

        if (userId === 0) {
            this.setState({
                userId: userId,
                scores: [],
                notes: []
            });
            return;
        }
        
        this.setState(
            {
                userId: userId,
                miniLoad: true
            }, 
            this.updateReport);
    }

    getModalElement(groupInd: number, charInd: number) {
        var char = this.state.groups[groupInd].scoreCardGroupCharacteristics[charInd];

        const props = {
            show: char.showModal,
            onHide: () => {
                this.toggleModal(groupInd, charInd);
            },
            title: char.name,
            content: char.desc
        };

        return (
            <div key={`modal-group-${groupInd}-charactersitic-${charInd}`}>
                <PonderaModal {...props} />
            </div>);
    }


    private scoreCardChange(e: any) {
        const scoreCardId: number = Number(e.target.value);

        if (scoreCardId !== -1) {
            const scoreCard = this.state.scoreCards.find(x => x.id === scoreCardId);

            this.setState(
                {
                    selectedScoreCardId: scoreCardId,
                    groups: scoreCard ? scoreCard.scoreCardGroups : []
                }, 
                this.updateReport
            );
        }
    }

    public render() {
        var defaultOptions = [{
            id: 0,
            value: '- Clear Selected -'
        }];

        var offset = 0;

        const scoreCardOptions = this.state.scoreCards.map((item: ScoreCard) => {
            return {
                id: item.id,
                label: item.name
            };
        });

        if (scoreCardOptions.length === 0) {
            scoreCardOptions.push(
                {
                    id: -1,
                    label: 'No Score Cards Available'
                }
            );
        }

        const notesTable = (
            <table className="table table-striped">
                <thead>
                    <tr>
                        <th>Created</th>
                        <th>Added By</th>
                        <th>Content</th>
                        <th>Public</th>
                        <th />
                    </tr>
                </thead>
                <tbody className="vertical-align-cells">
                    {this.state.notes.sort((a: UserScoreCardNote, b: UserScoreCardNote) => {
                        if (a.created > b.created) {
                            return -1;
                        } else if (a.created < b.created) {
                            return 1;
                        }
                        return 0;
                    }).map((note: UserScoreCardNote, ind: number) => {
                        if (!note.createdByUser) {
                            return <tr key={`note-${note.id}`}/>;
                        }
                        return <tr key={`note-${note.id}`}>
                            <td>
                                <span>{moment(note.created).format('L LT')}</span>
                            </td>
                            <td>
                                {note.createdByUser.lastName}, {note.createdByUser.firstName}
                            </td>
                            <td>
                                {this.canUpdateNote(note) && <textarea className="form-control" onChange={(e) => this.updateNoteContent(ind, e.target.value)}>{note.content}</textarea>}
                                {!this.canUpdateNote(note) && <textarea disabled className="form-control" >{note.content}</textarea>}
                            </td>
                            <td>
                                {this.canUpdateNote(note) && <input type="checkbox" checked={note.isPublic} onChange={(e) => this.updateNotePublic(ind)} />}
                                {!this.canUpdateNote(note) && <input type="checkbox" disabled checked={note.isPublic} />}
                            </td>
                            <td className="text-right">
                                {this.canUpdateNote(note) && <a className="btn btn-default" onClick={(e) => this.updateNote(note)}>Update</a>}
                                &nbsp;&nbsp;
                                {this.canUpdateNote(note) && <a className="btn btn-danger" onClick={(e) => this.deleteNote(note, ind)}>Delete</a>}
                            </td>
                        </tr>;
                    })}
                </tbody>
            </table>
        );

        const noteForm = (
            <div>
                <div className="row">
                    <div className="col-xs-11">
                        <label>Note</label>
                        <textarea className="form-control" value={this.state.note} onChange={(e) => this.setState({ note: e.target.value })} /> 
                    </div>
                    <div className="col-xs-1">
                        <label>Public?</label>
                        <input type="checkbox" checked={this.state.isPublic} onChange={(e) => this.setState({isPublic: !this.state.isPublic})} />
                    </div>
                </div>
                
                <br />
                <button className="btn btn-primary" disabled={this.state.note.length === 0} onClick={(e) => this.create()}>Add</button>
            </div>
        );

        return (
            <PVAPage>
                {this.organization && <div id={`organization-${this.organization.id}`} />}

                <PVAPage.Header>
                    <PVAPage.Header.Title>
                        <PVAPage.Header.Title.Text>
                            <span>Score Card<span className="trademark">TM</span></span>
                             <span className="light"> for </span>
                            <PVAUserSelect defaultOptions={defaultOptions} options={this.users} selected={this.state.userId} onChange={(e: any) => this.submit(e)} />
                            <PVASelect options={scoreCardOptions} selected={this.state.selectedScoreCardId} onChange={(e: any) => { this.scoreCardChange(e); }} />
                            {this.state.miniLoad && <LoadingIndicatorMini />}
                        </PVAPage.Header.Title.Text>
                    </PVAPage.Header.Title>
                </PVAPage.Header>

                <PVAPage.Body>
                    <div>

                        {this.state.groups.map((group: ScoreCardGroup, ind: number) => {
                            return group.scoreCardGroupCharacteristics.map((scgc: ScoreCardGroupCharacteristic, scgcInd: number) => {
                                return this.getModalElement(ind, scgcInd);
                            });
                        })}

                        {this.state.groups.map((group: ScoreCardGroup, ind: number) => {
                            
                            return <div key={`group-${group.id}`}>                                
                                <table className="table table-striped score-card-table">
                                    <tbody>
                                        <tr className="fusion-score-card-header">
                                            <td>
                                                <span>{group.name}</span>
                                            </td>
                                            <td className="score-card-header-cell">
                                                {group.low}
                                            </td>
                                            <td className="score-card-header-cell">
                                                {group.medium}
                                            </td>
                                            <td className="score-card-header-cell">
                                                {group.high}
                                            </td>
                                        </tr>
                                        {
                                            group.scoreCardGroupCharacteristics.map((scgc: ScoreCardGroupCharacteristic, scgcInd: number) => {
                                                offset++;

                                                var score = this.state.scores.find((uscgc: UserScoreCardGroupCharacteristic) => {
                                                    return uscgc.scoreCardGroupCharacteristicID === scgc.id;
                                                });

                                                return <tr key={`group-${group.id}-fgc-${scgc.id}`} className="fusion-score-card">
                                                    <td>
                                                        <span onClick={(e) => this.toggleModal(ind, scgcInd)} className="characteristic-info glyphicon glyphicon-info-sign icon-button" />
                                                        <span className="cursor-pointer" onClick={(e) => this.toggleModal(ind, scgcInd)}> {offset}. {scgc.name}</span>
                                                    </td>
                                                    <td>
                                                        <div className="fusion-score-card-grouping">
                                                            <input checked={(score && score.score === 1) ? true : false} type="radio" radioGroup={`fgc-${ind}-${scgcInd}`} name={`fgc-${ind}-${scgcInd}`} value={1} onChange={(e) => this.setScore(scgc, e.target.value)} />
                                                            <input checked={(score && score.score === 2) ? true : false} type="radio" radioGroup={`fgc-${ind}-${scgcInd}`} name={`fgc-${ind}-${scgcInd}`} value={2} onChange={(e) => this.setScore(scgc, e.target.value)} />
                                                            <input checked={(score && score.score === 3) ? true : false} type="radio" radioGroup={`fgc-${ind}-${scgcInd}`} name={`fgc-${ind}-${scgcInd}`} value={3} onChange={(e) => this.setScore(scgc, e.target.value)} />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="fusion-score-card-grouping">
                                                            <input checked={(score && score.score === 4) ? true : false} type="radio" radioGroup={`fgc-${ind}-${scgcInd}`} name={`fgc-${ind}-${scgcInd}`} value={4} onChange={(e) => this.setScore(scgc, e.target.value)} />
                                                            <input checked={(score && score.score === 5) ? true : false} type="radio" radioGroup={`fgc-${ind}-${scgcInd}`} name={`fgc-${ind}-${scgcInd}`} value={5} onChange={(e) => this.setScore(scgc, e.target.value)} />
                                                            <input checked={(score && score.score === 6) ? true : false} type="radio" radioGroup={`fgc-${ind}-${scgcInd}`} name={`fgc-${ind}-${scgcInd}`} value={6} onChange={(e) => this.setScore(scgc, e.target.value)} />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="fusion-score-card-grouping">
                                                            <input checked={(score && score.score === 7) ? true : false} type="radio" radioGroup={`fgc-${ind}-${scgcInd}`} name={`fgc-${ind}-${scgcInd}`} value={7} onChange={(e) => this.setScore(scgc, e.target.value)} />
                                                            <input checked={(score && score.score === 8) ? true : false} type="radio" radioGroup={`fgc-${ind}-${scgcInd}`} name={`fgc-${ind}-${scgcInd}`} value={8} onChange={(e) => this.setScore(scgc, e.target.value)} />
                                                            <input checked={(score && score.score === 9) ? true : false} type="radio" radioGroup={`fgc-${ind}-${scgcInd}`} name={`fgc-${ind}-${scgcInd}`} value={9} onChange={(e) => this.setScore(scgc, e.target.value)} />
                                                        </div>
                                                    </td>
                                                </tr>;
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>;
                        })}
                    </div>
                    {this.state.userId !== undefined && this.state.userId > 0 && this.state.selectedScoreCardId !== undefined && this.state.selectedScoreCardId > 0 && 
                        <>
                            <div>
                                <button className="btn btn-danger" onClick={(e) => this.clearScores()}>Clear Scores</button>
                            </div>
                    
                            <hr />
                            <PVAContainerSimple title={'Notes'} defaultOpen={false}>
                                {notesTable}
                            </PVAContainerSimple>
                            <hr />
                            <PVAContainerSimple title={'Add New Note'} defaultOpen={false}>
                                {noteForm}
                            </PVAContainerSimple>
                        </>
                    }
                </PVAPage.Body>
                <PVAPage.Footer />
            </PVAPage>);
    }

    private canUpdateNote(note: UserScoreCardNote) {
        if (this.props.UserStore && this.props.UserStore.userInfo) {
            if (note.createdByUserID === this.props.UserStore.userInfo.id) {
                return true;
            } else if (this.props.UserStore!.userRoleIn([Roles.SiteAdmin, Roles.SuperAdmin])) {
                return true;
            }
        }

        return false;
    }

    private deleteNote(note: UserScoreCardNote, ind: number) {
        this.userScoreCardNoteDataService.delete(note).then(() => {
            var notes = this.state.notes;
            var noteInd = this.state.notes.findIndex((findNote: UserScoreCardNote) => {
                if (findNote) {
                    return findNote.id === note.id;
                }
                return false;
            });
            if (noteInd > -1) {
                delete notes[noteInd];
                this.setState({
                    notes: notes
                });
            }
        });
    }

    private updateNote(note: UserScoreCardNote) {
        this.userScoreCardNoteDataService.update(note);
    }

    private updateNoteContent(ind: number, val: string) {
        var notes = this.state.notes;
        notes[ind].content = val;
        this.setState({
            notes: notes
        });
    }

    private updateNotePublic(ind: number) {
        var notes = this.state.notes;
        notes[ind].isPublic = !notes[ind].isPublic;
        this.setState({
            notes: notes
        });
    }

    private create() {
        if (this.state.userId) {
            var note = new UserScoreCardNote();
            note.userID = this.state.userId;
            note.content = this.state.note;
            note.isPublic = this.state.isPublic;
            note.scoreCardID = this.state.selectedScoreCardId!;
            this.userScoreCardNoteDataService.create(note).then((updatedNote: UserScoreCardNote) => {
                var notes = this.state.notes;
                notes.push(updatedNote);
                this.setState({
                    notes: notes,
                    note: '',
                    isPublic: false
                });
            });
        }
    }

    private clearScores() {
        if (this.state.userId && this.state.selectedScoreCardId && confirm(`Are you sure? This can't be undone`)) {
            this.userScoreCardGroupCharacteristicDataService.clear(this.state.userId, this.state.selectedScoreCardId).then(() => {
                this.setState({
                    scores: []
                });
            });
        }
    }

    private setScore(scgc: ScoreCardGroupCharacteristic, val: any) {
        const { userId } = this.state;

        var score = parseInt(val, 10);
        
        var existing = this.state.scores.find((uscgc: UserScoreCardGroupCharacteristic) => {
            return uscgc.scoreCardGroupCharacteristicID === scgc.id;
        }); 
        if (existing) {
            existing.score = score;

            if (userId > 0) {
                this.userScoreCardGroupCharacteristicDataService.save(existing);
            }

            this.forceUpdate();
        } else {
            existing = new UserScoreCardGroupCharacteristic();
            
            existing.score = score;
            existing.scoreCardGroupCharacteristicID = scgc.id;
            
            if (userId === 0) {
                existing.userID = userId;

                let {scores} = this.state;
                scores.push(existing);
                this.setState({
                    scores: scores
                });
            } else if (userId && userId > 0) {
                existing.userID = userId;
                this.userScoreCardGroupCharacteristicDataService.save(existing).then((uscgc: UserScoreCardGroupCharacteristic) => {
                    let {scores} = this.state;
                    scores.push(uscgc);
                    this.setState({
                        scores: scores
                    });
                });
            }
            
        }

        // }
    }
}



// WEBPACK FOOTER //
// ./src/components/reports/scoreCard/ScoreCardView.tsx